import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {OfferBox} from 'components/OfferBox/OfferBox'
import {UnavailabilityMobile} from 'components/Unavailability/Mobile'
import {useHotelOverlayOffersFilters} from 'hooks/useHotelOverlayOffersFilters'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'
import {HotelOfferEntity} from 'modules/sapiSearch/slice'

import {cssTheme} from '@vio/atlas/themes'
import {Page} from '@vio/core/src/analytics/types/Events'

import {FilterSource} from '../../../OffersFilters/constants'
import {UnavailabilityWithFilters} from '../../Unavailability'

interface Props {
  offerEntity: HotelOfferEntity
  showCashback?: boolean
  isLoading?: boolean
}

const SOURCE_COMPONENT = 'DesktopHotelViewTopOffers'

const AvailabilityPaneWrapper = styled.div`
  padding: ${cssTheme.layout.spacing.s400} ${cssTheme.layout.spacing.s400};
  border: 1px solid ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
  overflow: hidden;
`

export const TopOffersDesktop: React.FC<Props> = ({
  offerEntity,
  showCashback,
  isLoading
}) => {
  const hotelId = useSelector(getAccommodationPageHotelId)
  const {activeOffersFilters} = useHotelOverlayOffersFilters()
  const hasActiveFilters = !!activeOffersFilters.length
  return (
    <OfferBox
      offerBoxVariant="special"
      offerEntity={offerEntity}
      isLoading={isLoading}
      primaryOfferVariant="PrimaryMultiColumn"
      primaryOfferShouldShowTaxation={false}
      component={SOURCE_COMPONENT}
      unavailabilitySlot={
        hasActiveFilters ? (
          <UnavailabilityWithFilters source={FilterSource.RemoveQuickFilters} />
        ) : (
          <AvailabilityPaneWrapper>
            <UnavailabilityMobile
              hotelId={hotelId}
              sourceComponentPrefix="DesktopHotelView"
            />
          </AvailabilityPaneWrapper>
        )
      }
      shouldRenderUnavailabilitySlot
      page={Page.Accommodation}
      showCashback={showCashback}
      cashbackVariant="short"
    />
  )
}
